<div class="product-code-details" (click)="$event.stopPropagation()">
  <div class="physicals-detail-title">フィジカル売上枚数品番別内訳</div>
  <div class="physicals-title-label" fxLayout="row" fxLayoutAlign="space-between end">
    <div class="item product-title-label">タイトル</div>
    <div class="item detail-title-label" fxLayout="column">
      <div class="item physicals-title-value-label">
        フィジカル売上枚数（NET）
      </div>
      <div class="item physicals-title-value-label">
        消化率
      </div>
      <div class="item physicals-title-value-label">
        発売前出荷数
      </div>
      <div class="item physicals-title-value-label">
        D2C出荷枚数（NET)
      </div>
    </div>
  </div>

  @for (item of projectSales[0].physicalsDetail; track item) {
    <div>
      <mat-divider></mat-divider>
      <div fxLayout="row" fxLayoutAlign="space-between center" class="product-code-details-item">
        <div class="item" fxLayout="column">
          <div class="product-code-label">
            {{ item.productCode || '不明な品番' }}
          </div>
          <div class="product-name-label">
            {{ item.productName || '不明な商品名' }}
          </div>
        </div>
        <div class="item" fxLayout="column">
          <div class="item physicals-value-label">
            {{ item.physicalsProd | number }}
          </div>
          @if (item.digestibility != null && item.digestibility != 0.0) {
            <div
              class="item physicals-value-label"
              >
              {{ item.digestibility | number }}%
            </div>
          }
          @if (item.digestibility != null && item.digestibility == 0.0) {
            <div
              class="item physicals-value-label"
              >
              0%
            </div>
          }
          @if (item.digestibility == null) {
            <div class="item physicals-value-label">
              ‐
            </div>
          }
          <div class="item physicals-value-label">
            {{ item.preOrderPhysicalsProd | number }}
          </div>
          <div class="item physicals-value-label">
            {{ item.d2cPhysicalsProd | number }}
          </div>
        </div>
      </div>
    </div>
  }
</div>
